import React from "react";
import PropTypes from "prop-types";
import PillButton, { VARIANTS } from '../PillButton';

const SubmitAnswerButton = ({ submitAnswer, color }) => {
  return (
    <PillButton
      variant={color === "primary" ? VARIANTS.YELLOW : VARIANTS.YELLOW}
      onClick={submitAnswer}
      style={{ minWidth: "auto", fontSize: "15px", fontWeight: 500, padding: "6px 14px", color: "#fff" }}
    >
      Submit Answer
    </PillButton>
  );
};

SubmitAnswerButton.propTypes = {
  submitAnswer: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default SubmitAnswerButton;
